async function createFormData(data, pusher_id, image_url) {
    const formData = new FormData();

    formData.append("action", "FORM_SUBMIT");

    Object.keys(data).forEach(key => {
        if (key !== "original_image" && key !== "accepted" && key !== "card_template") {
            formData.append(key, data[key]);
        }
    });

    if (image_url) {
        const fileInput = document.getElementById('original_image');
        try {
            if (fileInput && fileInput.files && fileInput.files.length > 0) {
                const file = await imageUrlToFile(image_url, fileInput.files[0].name);
                formData.append('original_image', file);
            }
        } catch (error) {
            const fileInput = document.getElementById('original_image');
            if (fileInput && fileInput.files && fileInput.files.length > 0) {
                formData.append('original_image', fileInput.files[0]);
            }
        }
    } else {
        const fileInput = document.getElementById('original_image');
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            formData.append('original_image', fileInput.files[0]);
        }
    }

    formData.append("pusher_id", pusher_id);

    return formData;
}

export default createFormData;

async function imageUrlToFile(url, fileName) {
    const blob = await fetchImage(url);
    const file = blobToFile(blob, fileName);
    return file;
}

async function fetchImage(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return blob;
}

function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type });
}
